const enNZ = {};

export { enNZ };
